import axios from "axios";

const client = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/booking` });
export const custToken = () => localStorage.getItem("cust_token");
client.interceptors.request.use((c) => {
  const t = custToken();
  if (t && !c.headers.Authorization) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
export const bookingHttp = client;
const d = (r) => r.data;

export const bk = {
  catalog: () => client.get("/catalog").then(d),
  publicConfig: () => client.get("/public-config").then(d),
  contact: (p) => client.post("/contact", p).then(d),
  estimate: (p) => axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/agreements/estimate`, p).then(d),
  requestAgreement: (p) => client.post("/../agreements/request", p).then(d),
  myAgreements: () => client.get("/../agreements/mine").then(d),
  price: (p) => client.post("/price", p).then(d),
  availability: (day, hours) => client.get("/availability", { params: { day, hours } }).then(d),
  coverage: (postcode) => client.get("/coverage", { params: { postcode } }).then(d),
  create: (p) => client.post("/bookings", p).then(d),
  status: (id, session_id) => client.get(`/bookings/${id}/status`, { params: { session_id } }).then(d),
  register: (p) => client.post("/auth/register", p).then(d),
  login: (p) => client.post("/auth/login", p).then(d),
  me: () => client.get("/me").then(d),
  updateMe: (p) => client.put("/me", p).then(d),
  myBookings: () => client.get("/my-bookings").then(d),
  cancel: (id) => client.post(`/my-bookings/${id}/cancel`).then(d),
};

const adminH = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
export const bkAdmin = {
  bookings: (status) => client.get("/admin/bookings", { params: { status }, ...adminH() }).then(d),
  updateBooking: (id, p) => client.put(`/admin/bookings/${id}`, p, adminH()).then(d),
  refund: (id) => client.post(`/admin/bookings/${id}/refund`, {}, adminH()).then(d),
  services: () => client.get("/admin/services", adminH()).then(d),
  updateService: (slug, p) => client.put(`/admin/services/${slug}`, p, adminH()).then(d),
  updateAddon: (key, p) => client.put(`/admin/addons/${key}`, p, adminH()).then(d),
  settings: () => client.get("/admin/settings", adminH()).then(d),
  saveSettings: (p) => client.put("/admin/settings", p, adminH()).then(d),
  cleaners: () => client.get("/admin/cleaners", adminH()).then(d),
  overview: () => client.get("/admin/overview", adminH()).then(d),
  codes: () => client.get("/admin/codes", adminH()).then(d),
  saveCode: (p) => client.post("/admin/codes", p, adminH()).then(d),
  customers: () => client.get("/admin/customers", adminH()).then(d),
  emails: () => client.get("/admin/emails", adminH()).then(d),
  contacts: () => client.get("/admin/contacts", adminH()).then(d),
  contactHandled: (id) => client.post(`/admin/contacts/${id}/handled`, {}, adminH()).then(d),
  agreements: () => client.get("/../agreements/admin", adminH()).then(d),
  updateAgreement: (id, p) => client.put(`/../agreements/admin/${id}`, p, adminH()).then(d),
  addCleaner: (p) => client.post("/admin/cleaners", p, adminH()).then(d),
  updateCleaner: (id, p) => client.put(`/admin/cleaners/${id}`, p, adminH()).then(d),
};

export const nok = (n) => `${Number(n || 0).toLocaleString("nb-NO", { maximumFractionDigits: 0 })} kr`;
export const errMsg = (e) => e?.response?.data?.detail?.toString?.() || "Noe gikk galt";
export const STATUS_LABEL = { venter_betaling: "Venter på betaling", venter_godkjenning: "Venter på godkjenning", bekreftet: "Bekreftet", pa_vei: "På vei", fullfort: "Fullført", avbestilt: "Avbestilt", utlopt: "Utløpt" };
